import { DemDownloaderComponent } from './../tools/dem-downloader/dem-downloader.component';
import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

import { Router } from '@angular/router';
import { LegendToolComponent } from '../tools/legend-tool/legend-tool.component';
import { MetricxComponent } from '../tools/metricx/metricx.component';
import { AdvanceSelectComponent } from '../tools/advance-select/advance-select.component';
import { DownloadViewComponent } from '../tools/download-view/download-view.component';
import { QueryComponent } from '../tools/query/query.component';
import { BookmarkComponent } from '../tools/bookmark/bookmark.component';
import { LiveShareComponent } from '../tools/live-share/live-share.component';
import { LiveshareEmbedComponent } from '../tools/liveshare-embed/liveshare-embed.component';
import { AnnotationComponent } from '../tools/annotation/annotation.component';
import { InformationComponent } from '../tools/information/information.component';
import { PrintviewComponent } from '../tools/printview/printview.component';
import { ZoomToPerimeterComponent } from '../tools/zoom-to-perimeter/zoom-to-perimeter.component';
import { LiveShareGeoLockComponent } from '../tools/live-share-geo-lock/live-share-geo-lock.component';

import { CaptureToolComponent } from '../tools/capture-tool/capture-tool.component';
import { HttpClient } from '@angular/common/http';
import { CaptureToolService } from '../../services/Capture-Tool/capture-tool.service';

import { MapServiceService } from '../../services/Map-service/map-service.service';
import { environment } from 'src/environments/environment';

import { ForwardBackwardToolServiceService } from '../../services/forward_backward/forward-backward-tool-service.service';
import { SideNavService } from '../../services/sidenav/side-nav.service';
import { ShareLinkService } from '../../services/Share-Link/share-link.service';
import { getHeaderUrls } from './headerUrls';

import * as CryptoJS from 'crypto-js';
import { drawZoomBox } from './zoomBox.';
import { googleView } from './googleStreetView';
import { AssessorParcelsService } from '../../services/Assessor-Parcels/assessor-parcels.service';
import { fromLonLat, transform } from 'ol/proj';
import WKT from 'ol/format/WKT';
import { Icon, Style } from 'ol/style';
import { containsCoordinate } from 'ol/extent';
import { GeoLocationService } from 'src/app/services/geo-location/geo-location.service';
import { GpsErrorModalComponent } from '../../modals/gps-error-modal/gps-error-modal.component';
import { MatDialog } from '@angular/material/dialog';
import VectorSource from 'ol/source/Vector';
import VectorImageLayer from 'ol/layer/VectorImage';
import proj4 from 'proj4';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-map-header',
  templateUrl: './map-header.component.html',
  styleUrls: ['./map-header.component.css'],
})
export class MapHeaderComponent implements OnInit,  AfterViewInit, OnDestroy {
  public innerWidth: any;
  windowWidth: number = window.innerWidth;
  windowHeight: number = window.innerHeight;
  toggleActive = false;
  sub: any;
  public width!: number;
  public height!: number;
  download: any;
  ipAddress: any;
  display = false;
  showReports = false;
  ShortcutKeyCheck = false;
  hideHeader = false;
  eventlog = false;
  toolActive: any = false;
  keyData: Array<any> = [];
  public searchValue: any[] = [];
  coordinates: any
  showClose: any;
  toolExpand = false;
  toolCollapse = true;
  showFullScreenIcon = false;
  ShortcutKey = false;
  toggleID: any;
  loader: any;
  subMenu: any;
  dashUrl: any;
  toolData: any;
  showLocation = false
  backForwordTool = false
  searchType: any;
  mapsUrl: any;
  previousId: any;
  activeInfo: any;
  zoomBoxPanle: any;
  checkboxType = 'checkbox';
  radioType = 'radio';
  firstName: any;
  lastName: any;
  embedUrl: any;
  accountUrl: any;
  mapName: any;
  search: any;
  myOptions: any;
  HideForEmbed = 'false';
  eventName: any;
  loginShow = false;
  isDesktop: any = true
  geoLockTool: any;
  token: any;
  showLogin: any;
  mapId: any;
  tools: any;
  siteTitle: any;
  subTitle: any;
  controls: any = [];
  mobile = false;
  panToZoomTool = false
  allUserReports: any;
  userLevel: any;
  mapLogo: any;
  mapLogoUrl: any;
  infoId: any;
  previousId1: any;
  toolTips: any;
  headerNews: any;
  headerSupport: any;
  decrypted: any;
  latitudeDegrees: any
  longiDegrees: any
  headerContactUs: any;
  hearderUrlsData: any = {};
  showDemigod: any;
  geoLocationActive = false;
  isActive = false;
  message = 'SuperSecret!!';
  userEn = 'userEncrpto';
  myOptions1: any = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class3',
  };
  myOptions2: any = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class4',
  };

  information = {
    id: 15,
    toolName: 'Information',
    show: 'true',
    tooltip: {
      id: 15,
      name: 'Information',
      keyword: 'I',
      description:
        'See general information about operations and other aspects of this map.',
    },
  };

  constructor(
    public auth: AuthService,
    public sidenav: SideNavService,
    public mapService: MapServiceService,
    public shareLinkService: ShareLinkService,
    public captureToolService: CaptureToolService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private http: HttpClient,
    public forwardBackwardService: ForwardBackwardToolServiceService,
    public assessorParcelService: AssessorParcelsService,
    private geolocationService: GeoLocationService,
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) {
    const name = this.mapService.mapData.map_data.map_data.name;
    this.mapName = name;

    // comment for testing uncomment later
    this.decrypted = localStorage.getItem('user') || '';
    if (!this.decrypted) {
      this.firstName = '';
      this.lastName = '';
    } else {
      const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.userEn);
      const user = decrypted.toString(CryptoJS.enc.Utf8);
      const userdetail = JSON.parse(user);
      if (userdetail) {
        this.firstName = userdetail.user.first_name;
        this.lastName = userdetail.user.last_name;
      }
    }

    this.myOptions = {
      placement: 'bottom-right',
    };
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.ipAddress = res.ip;
      });
  }



  ngOnInit(): void {
    if (window.screen.width === 360) {
      // 768px portrait
      this.mobile = true;

    }
    this.deskTop()
    this.mapService.hideHeader.subscribe((res: any) => {
      this.hideHeader = res;
    });
    this.shareLinkService.fullScreenEmbedTool.subscribe((res: any) => {
      this.showFullScreenIcon = res;
    });
    //for testingt
    // this.hideHeader = true;
    this.HideForEmbed = this.mapService.embed;

    this.decrypted = localStorage.getItem('userAccessLevel');
    if (this.decrypted) {
      const decrypted = CryptoJS.AES.decrypt(this.decrypted, this.message);
      this.userLevel = decrypted.toString(CryptoJS.enc.Utf8);
    }
    if (!localStorage.getItem('subLevel')) {
      this.subMenu = this.userLevel;
    } else {
      this.subMenu = localStorage.getItem('subLevel');
    }
    this.showLogin = localStorage.getItem('first_login');
    this.token = localStorage.getItem('auth_token');
    this.keyword();
    this.navItems;
    this.showClose = false;
    // this.toolData = this.sidenav.legendToolData();
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.headerSupport  =this.mapService.mapData.map_data.support_link
    this.mapLogo = this.mapService.mapInterface.map_logo_url;
    this.mapLogoUrl = this.mapService.mapInterface.logo_hyperlink;
    this.tools = this.mapService.mapData.map_data.map_data.tools;
    this.toolTips = this.mapService.mapData.map_data.map_data.tools_tips;
    this.search = this.mapService.mapData.map_data.map_data.tools.search;
    this.mapService.isGeolock.subscribe((res: any) => {
      this.geoLockTool = res;
      this.search = this.mapService.mapData.map_data.map_data.tools.search;
    });

    this.siteTitle = this.mapService.mapInterface.site_title;
    this.subTitle = this.mapService.mapInterface.site_subtitle;
    this.sub = this.mapService.mapInterface.subtitle;
    this.mapService.closeLeft.subscribe((res: any) => {
      if (res) {
        this.setActive(
          this.mapService.toolId,
          'customButton',
          this.mapService.toolData
        );
      }
    });
    this.sidenav.loadfirstTime.subscribe(() => {
      const annot = {
        component: AnnotationComponent,
        show: 'false',
      };
      const legendTool = {
        component: LegendToolComponent,
        show: 'false',
      };
      this.toolData =
        this.mapService.accessMapApi.map_data.map_data.tools_tips.search;

      this.setActive(0, 'fake', annot);
      this.sidenav.loadFirstTimeAnnot = true;
      //loadAnnotationFakely
      setTimeout(() => {
        this.setActive(0, 'fake', legendTool);
      }, 10);

      //open info by default
      if (this.tools.right_panel) {
        setTimeout(() => {
          //load legend at the start
          this.sidenav.temporaryDisabled = true;
          this.info();
        }, 10);
      }
      if (
        this.tools.left_panel &&
        this.tools.layers &&
        this.mapService.mapData.map_data.share.live_share == false
      ) {
        setTimeout(() => {
          //load legend at the start
          this.sidenav.temporaryDisabled = true;
          this.setActive(1, 'customButton', this.navItems[0]);
        }, 10);
      } else if (
        this.tools.left_panel &&
        this.mapService.mapData.map_data.share.show_legend == true
      ) {
        setTimeout(() => {
          //load legend at the start
          this.sidenav.temporaryDisabled = true;
          this.setActive(1, 'customButton', this.navItems[0]);
        }, 100);
      } else if (this.HideForEmbed) {
        setTimeout(() => {
          //load legend at the start
          this.sidenav.temporaryDisabled = true;
          this.setActive(1, 'customButton', this.navItems[0]);
        }, 100);
      }
    });

    this.sidenav.infoClicked.subscribe((res) => {
      if (res == 0) {
        this.activeInfo = false;
      }
    });
    this.hideShowTools();
    this.toolsToolTips();
    setTimeout(() => {
      if (localStorage.getItem('demigodBack')) {
        this.showDemigod = true;
      }
    }, 500);
    this.elementsById('submit-pdf1 submit-pdf2');


  }
  ngAfterViewInit() {
    this.mapService.vectorDrawSource = new VectorSource();
    this.mapService.geoLocationLayer = new VectorImageLayer({
      source: this.mapService.vectorDrawSource,
      zIndex: 100,
      renderBuffer: 1e10,
    });
    setTimeout(() => {
      this.mapService.mapLayer.addLayer(this.mapService.geoLocationLayer);
    }, 500);
  }
  elementsById(ids: any) {
    this.mapsUrl = `${environment.opLink}/my_maps/${this.token}`;
    this.dashUrl = `${environment.opLink}/dashboard/${this.mapId}/${this.token}`;
    if (this.userLevel === '500') {
      switch (this.mapService.mapInterface.map_type) {
        case 'pv-map':
          this.accountUrl = `${environment.operatorDashboardUrl}/parcelviewer/account/${this.token}`;
          break;
        case 'custom-map':
          this.accountUrl = `${environment.operatorDashboardUrl}/customviewer/account/${this.token}`;
          break;
        default:
          this.accountUrl = `${environment.operatorDashboardUrl}/wildfireviewer/account/${this.token}`;
          break;
      }
    } else {
      this.accountUrl = '/dashboard/';
    }
    const idList = ids.split(' ');
    for (let i = 0; i < idList.length; i++) {
      const element1: any = document.getElementById(idList[i]);
      if (element1) {
        switch (idList[i]) {
          case 'submit-pdf1':
            element1.href = this.mapsUrl;
            break;
          case 'submit-pdf2':
            element1.href = this.dashUrl;
            break;
          default:
            element1.href = this.accountUrl;
            break;
        }
      }
    }
  }
  //when user is typing in search box
  didModify(e: any) {
    /* eslint-disable */
    // const regex = /^(\-?\d+)°\s*(\d+)′\s*(\d+\.\d+)″\s*([NSEW])\s*(,\s*(\-?\d+)°\s*(\d+)′\s*(\d+\.\d+)″\s*([NSEW]))?\s*$/;
    this.coordinates = []
    const hasDegreeSymbol = e.indexOf("°") !== -1;
    const spacesCount = e.split(" ").length - 1;
    if (hasDegreeSymbol || spacesCount > 4) {
      const val = e.replace(/[°'"′″]/g, '');
      const list = val.split(",").map((part: any) => part.trim().split(/\s+/));
      // Extract the latitude and longitude parts and split them into arrays
      if(list.length == 1) {
        const latitude = list[0]
        // const longi = longitude.filter((n: any) => !isNaN(n));
        if(latitude) {
          this.latitudeDegrees = +latitude[0] + +latitude[1] / 60 + +latitude[2] / 3600;
          if ((latitude[3] === 'S' || latitude[3] === 'W') && this.latitudeDegrees >= 0) {
            this.latitudeDegrees = -this.latitudeDegrees;
          }
        }
        if(latitude) {
          this.longiDegrees = +latitude[4] + +latitude[5] / 60 + +latitude[6] / 3600;
          if ((latitude[7] === 'S' || latitude[7] === 'W') && this.longiDegrees >= 0) {
            this.longiDegrees = -this.longiDegrees;
          }
        }
      } else {
        const latitude = list[0]
        const longitude = list[1]
        // const longi = longitude.filter((n: any) => !isNaN(n));
        if(latitude) {
          this.latitudeDegrees = +latitude[0] + +latitude[1] / 60 + +latitude[2] / 3600;
          if ((latitude[3] === 'S' || latitude[3] === 'W') && this.latitudeDegrees >= 0) {
            this.latitudeDegrees = -this.latitudeDegrees;
          }
        }
        if(longitude) {
          this.longiDegrees = +longitude[0] + +longitude[1] / 60 + +longitude[2] / 3600;
          if ((longitude[3] === 'S' || longitude[3] === 'W') && this.longiDegrees >= 0) {
            this.longiDegrees = -this.longiDegrees;
          }
        }
      }

      const coor = this.latitudeDegrees.toFixed(5) + ',' + this.longiDegrees.toFixed(5);
      this.coordinates = coor
      this.panToZooom()
    }
      else if (e.includes(",")) {
      this.coordinates = e
      this.panToZoomTool = true
    } else {
      this.removeFeature()
      this.panToZoomTool = false
      if (this.searchValue.length == 0) {
        this.loader = false;
      } else if (this.searchValue.length >= 1) this.loader = true;
      this.showClose = true;
      this.searchType = 'autoComplete';
    }


  }
  //when user enter data and press enter key
  completeSearch() {
    const regex = /^(\d{1,2})°\s(\d{1,2})′\s(\d{1,2}\.\d{1,2})″\s[NSEW]\s,\s(\d{1,3})°\s(\d{1,2})′\s(\d{1,2}\.\d{1,2})″\s[NSEW]$/;
    this.coordinates = []
    const data: any =this.searchValue
    const hasDegreeSymbol = data.indexOf("°") !== -1;
    const spacesCount = data.split(" ").length - 1;
    if (hasDegreeSymbol || spacesCount > 4) {
      const val = data.replace(/[°'"′″]/g, '');
      const list = val.split(",").map((part: any) => part.trim().split(/\s+/));
      // Extract the latitude and longitude parts and split them into arrays
      if(list.length == 1) {
        const latitude = list[0]
        // const longi = longitude.filter((n: any) => !isNaN(n));
        if(latitude) {
          this.latitudeDegrees = +latitude[0] + +latitude[1] / 60 + +latitude[2] / 3600;
          if ((latitude[3] === 'S' || latitude[3] === 'W') && this.latitudeDegrees >= 0) {
            this.latitudeDegrees = -this.latitudeDegrees;
          }
        }
        if(latitude) {
          this.longiDegrees = +latitude[4] + +latitude[5] / 60 + +latitude[6] / 3600;
          if ((latitude[7] === 'S' || latitude[7] === 'W') && this.longiDegrees >= 0) {
            this.longiDegrees = -this.longiDegrees;
          }
        }
      } else {
        const latitude = list[0]
        const longitude = list[1]
        // const longi = longitude.filter((n: any) => !isNaN(n));
        if(latitude) {
          this.latitudeDegrees = +latitude[0] + +latitude[1] / 60 + +latitude[2] / 3600;
          if ((latitude[3] === 'S' || latitude[3] === 'W') && this.latitudeDegrees >= 0) {
            this.latitudeDegrees = -this.latitudeDegrees;
          }
        }
        if(longitude) {
          this.longiDegrees = +longitude[0] + +longitude[1] / 60 + +longitude[2] / 3600;
          if ((longitude[3] === 'S' || longitude[3] === 'W') && this.longiDegrees >= 0) {
            this.longiDegrees = -this.longiDegrees;
          }
        }
      }
      const coor = this.latitudeDegrees.toFixed(5) + ',' + this.longiDegrees.toFixed(5);
      this.coordinates = coor
      this.panToZooom()
    }else if (this.searchValue.includes(",")) {
      this.coordinates = this.searchValue
      this.panToZooom()
    } else {
      this.removeFeature()
      this.panToZoomTool = false
      if (this.searchValue.length > 0) {
        this.loader = true;
        this.showClose = true;
        this.searchType = 'quick';
      }
    }

  }

  panToZooom() {
    this.removeFeature()
    const nameArr = this.coordinates.split(',');
    if (nameArr.length > 2 && nameArr.length == 3) {
      for (let i = 0; i < nameArr.length; i++) {
        if (/^\d+$/.test(nameArr[i].trim())) {
        } else if (/^\d+[a-zA-Z]$/.test(nameArr[i].trim())) {
          if (i == 0) {
            const firstElement = nameArr.shift();
            nameArr.push(firstElement)
          }
        } else {
          console.log(`${nameArr[i]}`);
        }
      }
      // Define the Northings, Eastings, and Zone values
      const zone = nameArr[2]
      const res = zone.replace(/\D/g, "");
      // Define the source coordinate reference system (Northings, Eastings, and Zone)
      const src = `+proj=utm +zone=${+res} +ellps=WGS84 +datum=WGS84 +units=m +no_defs`;
      // Define the target coordinate reference system (Latitude, Longitude)
      const dest = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";

      const eastings = +nameArr[0]
      const northings = +nameArr[1]
      // Transform the Northings, Eastings, and Zone values to Latitude and Longitude
      if(eastings) {
        const [longitude, latitude] = proj4(src, dest, [eastings, northings]);
        this.getLatLon(longitude, latitude)
      } else {
        this.panToZoomTool = false
        this.loader = true;
        this.showClose = true;
        this.searchType = 'autoComplete';
      }

    }  else if(nameArr.length == 2 && Number.isInteger(+nameArr[0])) {
        const center = this.mapService.mapLayer.getView().getCenter();
        const lonLat = transform([center[0], center[1]], 'EPSG:3857', 'EPSG:4326');
        // Define the extent of the zone
        const zoneDefalut = Math.floor((lonLat[0] + 180) / 6) + 1;
        // Define the source coordinate reference system (Northings, Eastings, and Zone)
        const src = `+proj=utm +zone=${+zoneDefalut} +ellps=WGS84 +datum=WGS84 +units=m +no_defs`;
        // Define the target coordinate reference system (Latitude, Longitude)
        const dest = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";

        const eastings = +nameArr[0]
        const northings = +nameArr[1]
        // Transform the Northings, Eastings, and Zone values to Latitude and Longitude
        if(eastings) {
          const [longitude, latitude] = proj4(src, dest, [eastings, northings]);
          this.getLatLon(longitude, latitude)
        } else {
          this.panToZoomTool = false
          this.loader = true;
          this.showClose = true;
          this.searchType = 'autoComplete';
        }
    } else {
      const lat: any = nameArr[0]
      const lon = nameArr[1]
      this.getLatLon(lon, lat)
    }

  }

  getLatLon(lon: any, lat: any) {
    const lonLat = transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    const extent = this.mapService.mapData.map_data.map_data.initial_bounds;
    const location = containsCoordinate(extent, lonLat);
    if(location) {
      const format = new WKT();
      const feature = format.readFeature(`POINT (${lonLat[0]} ${lonLat[1]})`);
      // Coordinates Style
      const style = new Style({
        image: new Icon({
          src: '/assets/img/marker_resize.png',
          imgSize: [80, 150],
          offset: [-20, -37],
          scale: 1.0,
          opacity: 1.0,
        }),
      });
      feature.set('id', 'panToZoom');
      feature.setStyle(style);
      this.mapService.listResult.addFeatures([feature]);
      this.clickToZoom()
    }

  }

  clickToZoom() {
    const allFeatures = this.mapService.listResult.getFeatures();
    for (let i = 0; i < allFeatures.length; i++) {
      if (allFeatures[i].get('id') == 'panToZoom') {
        this.mapService.mapLayer
          .getView()
          .fit(allFeatures[i].getGeometry().getExtent(), { maxZoom: 18 });
      }

    }

  }

  removeFeature() {
    const backSource = this.mapService.result.getSource();
    const features = this.mapService.listResult.getFeatures();
    features.forEach((feature: any) => {
      backSource.removeFeature(feature);
    });
  }

  // when data is loaded in UI componenet then loader is false & close icon will be show
  loaded(value: any) {
    if (value == true) {
      this.loader = false;
      this.showClose = true;
    } else if (value == false) {
      this.loader = false;
      this.showClose = true;
    }
  }

  doneSearch() {
    this.clearSearch();
  }

  clearSearch() {
    this.searchValue = [];
    this.coordinates = []
    this.showClose = false;
    this.loader = false;
    this.removeFeature()
  }

  logOut(): void {
    this.mapService.isLiveShareLink = 'false';
    const colType = localStorage.getItem('coltype');
    if (colType === 'collaborate') {
      const body: any = { map: +this.mapService.mapId };
      this.mapService.collaboratorDestroySession(body).subscribe(() => {
        localStorage.clear();
        this.router.navigate(['login']);
      });
      this.loginShow = true;
    } else {
      localStorage.clear();
      this.router.navigate(['login']);
      this.loginShow = true;
    }
  }
  login() {
    this.router.navigate(['login']);
  }

  hideTool() {
    this.display = true;
    this.mobile = true;
    setTimeout(() => {
      this.sidenav.onResize();
    }, 10);
  }
  showTool() {
    this.display = false;
    setTimeout(() => {
      this.sidenav.onResize();
    }, 10);
  }

  deskTop() {
    this.isDesktop = this.deviceService.isDesktop();
    const deviceInfo  =this.deviceService.getDeviceInfo();
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.deskTop()
    this.innerWidth = window.innerWidth;
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
    if (this.innerWidth > 768) {
      this.display = false;
    }

  }



  // <======================tools toggle with key==========================>
  @HostListener('document:keypress', ['$event'])
  onKeypressEvent(event: any) {
    let decide: any = false;
    for (let i = 0; i < this.navItems.length; i++) {
      if (
        this.navItems[i].tooltip.keyword?.toUpperCase() ==
        event.key?.toUpperCase() &&
        this.navItems[i].display == true
      ) {
        decide = true;
        break;
      }
    }
    if (event.key == 'r' && decide) {
      if (
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT' &&
        event.target.tagName.toUpperCase() != 'DIV'
      ) {
        this.reFresh();
        return;
      }
    }
    if (event.key == 'o' && decide) {

      if (
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT' &&
        event.target.tagName.toUpperCase() != 'DIV'
      ) {
        if (this.keyData.includes(event.key)) {
          this.navItems.forEach((element) => {
            if (element.tooltip.keyword.toLowerCase() === event.key) {
              this.setActive(element.tooltip.id, 'customButton', element);
              this.backForwordTool = true
              // debugger
              // if (!this.ShortcutKey) {
              //   this.ShortcutKey = true;
              //   this.activityLoging(
              //     'Shortcut',
              //     element.displayName + ':Activate'
              //   );
              // } else {
              //   this.ShortcutKey = false;
              //   this.activityLoging(
              //     'Shortcut',
              //     element.displayName + ':Deactivate'
              //   );
              // }
              this.toggleID = element.tooltip.id;

            }
          });
          // this.toggleRightSidenav(this.toggleID);
        }
        this.zoomBox();
        return;
      }
    }
    if (event.key == 'g' && decide) {
      if (
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT' &&
        event.target.tagName.toUpperCase() != 'DIV'
      ) {
        if (this.keyData.includes(event.key)) {
          this.navItems.forEach((element) => {
            if (element.tooltip.keyword.toLowerCase() === event.key) {
              this.ShortcutKeyCheck = true;
              this.setActive(element.tooltip.id, 'customButton', element);
              if (!this.ShortcutKey) {
                this.ShortcutKey = true;
                this.activityLoging(
                  'Shortcut',
                  element.displayName + ':Activate'
                );
              } else {
                this.ShortcutKey = false;
                this.activityLoging(
                  'Shortcut',
                  element.displayName + ':Deactivate'
                );
              }
              this.toggleID = element.tooltip.id;
            }
          });
          // this.toggleRightSidenav(this.toggleID);
        }
        this.googleStreetView();
        return;
      }
    }

    if ((event.key == 'k' || event.key === 'z') && decide) {
      if (
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT' &&
        event.target.tagName.toUpperCase() != 'DIV'
      ) {
        this.mapService.setParcelKey(event.key);
        return;
      }
    }

    if (
      (decide &&
        event.key == 'b' &&
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT') &&
        event.target.tagName.toUpperCase() != 'DIV' ||
      (event.key == 'b' && event.target.type === 'checkbox') ||
      (event.key == 'b' && event.target.type === 'radio') ||
      (event.key == 'b' && event.target.type === 'select-one')
    ) {
      this.backForwordTool = true
      this.forwardBackward(3);
      return
    }
    if (
      (decide &&
        event.key == 'f' &&
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT') &&
        event.target.tagName.toUpperCase() != 'DIV' ||
      (event.key == 'f' && event.target.type === 'checkbox') ||
      (event.key == 'f' && event.target.type === 'radio') ||
      (event.key == 'f' && event.target.type === 'select-one')
    ) {
      this.backForwordTool = true
      this.forwardBackward(4);
      return
    }

    if (
      (event.key == 'i' &&
        event.target.tagName.toUpperCase() != 'INPUT' &&
        event.target.tagName.toUpperCase() != 'TEXTAREA' &&
        event.target.tagName.toUpperCase() != 'SELECT') &&
        event.target.tagName.toUpperCase() != 'DIV' ||
      (event.key == 'i' && event.target.type === 'checkbox') ||
      (event.key == 'i' && event.target.type === 'radio') ||
      (event.key == 'i' && event.target.type === 'select-one')
    ) {
      this.infoId = 15;
      this.mapService.stopHover = false;
      if (this.infoId === this.previousId1) {
        this.previousId1 = 0;
        this.sidenav.closeRightSideNav();
        this.sidenav.infoSideNav('closed');
        this.activeInfo = false;
      } else {
        this.sidenav.rightMenuClicked({
          id: 15,
          component: InformationComponent,
          data: null,
          history: false,
          push: false,
        });
        this.activeInfo = true;
        this.previousId1 = 15;
        this.sidenav.infoSideNav('open');
      }
    } else if (
      decide &&
      event.target.tagName.toUpperCase() != 'INPUT' &&
      event.target.tagName.toUpperCase() != 'TEXTAREA' &&
      event.target.tagName.toUpperCase() != 'SELECT' &&
      event.target.tagName.toUpperCase() != 'DIV'
    ) {
      debugger
      if (this.keyData.includes(event.key)) {
        this.navItems.forEach((element) => {
          if (element.tooltip.keyword.toLowerCase() === event.key) {
            this.ShortcutKeyCheck = true;
            this.setActive(element.tooltip.id, 'customButton', element);
            if (!this.ShortcutKey) {
              this.ShortcutKey = true;
              this.activityLoging(
                'Shortcut',
                element.displayName + ':Activate'
              );
            } else {
              this.ShortcutKey = false;
              this.activityLoging(
                'Shortcut',
                element.displayName + ':Deactivate'
              );
            }

            this.toggleID = element.tooltip.id;
          }
        });
        // this.toggleRightSidenav(this.toggleID);
      }
      return;
    } else if (event.target.type === 'checkbox' && decide) {
      if (this.keyData.includes(event.key)) {
        this.navItems.forEach((element) => {
          if (element.tooltip.keyword.toLowerCase() === event.key) {
            this.setActive(element.tooltip.id, 'customButton', element);
            this.toggleID = element.tooltip.id;
            this.activityLoging('Shortcut', element.displayName);
          }
        });
      }
      return;
    } else if (event.target.type === 'radio' && decide) {
      if (this.keyData.includes(event.key)) {
        this.navItems.forEach((element) => {
          if (element.tooltip.keyword.toLowerCase() === event.key) {
            this.setActive(element.tooltip.id, 'customButton', element);
            this.toggleID = element.tooltip.id;
            this.activityLoging('Shortcut', element.displayName);
          }
        });
      }
      return;
    } else if (event.target.type === 'select-one' && decide) {
      if (this.keyData.includes(event.key)) {
        this.navItems.forEach((element) => {
          if (element.tooltip.keyword.toLowerCase() === event.key) {
            this.setActive(element.tooltip.id, 'customButton', element);
            this.toggleID = element.tooltip.id;
            this.activityLoging('Shortcut', element.displayName);
          }
        });
      }
      return;
    }
  }
  // <======================Open tool with keyword==========================>
  keyword() {
    const newItems: any[] = [];
    this.navItems.forEach((element) => {
      newItems.push(element.tooltip.keyword.toLowerCase());
    });
    this.keyData = newItems;
  }
  // <======================tools toggle with click==========================>
  toggleRightSidenav(id: number, name: any) {
    if (
      id === 1 ||
      id === 6 ||
      id === 7 ||
      id === 8 ||
      id === 9 ||
      id === 11 ||
      id === 12 ||
      id === 13 ||
      id === 14 ||
      id === 15 ||
      id === 17 ||
      id == 18
    ) {
      if (id === 18) {
        this.captureToolService
          .getLayerGeomTypes(this.mapId)
          .subscribe((res: any) => {
            this.mapService.setGeomType(res);
          });
      }
      this.toggleActive = !this.toggleActive;
      if (this.toggleActive == true) {
        this.sidenav.leftSideNavState('closed');
      } else {
        this.sidenav.leftSideNavState('open');
      }
      this.sidenav.toggle();
    } else {
      this.sidenav.close();
      this.sidenav.leftSideNavState('closed');
    }
    this.mapService.getToolName(name);
    this.eventName = name;
  }
  // <======================Info tool==========================>
  info(): void {
    //hover deactivate
    //disabled hidden tag
    if (this.sidenav.hideRightPanelForImage) {
      this.sidenav.closeRightSideNav();
      this.sidenav.hideRightPanelForImage = false;
      this.sidenav.showAnimateNow = false;
    }
    this.mapService.stopHover = false;
    this.activeInfo = !this.activeInfo;

    // setTimeout(() => {
    if (this.activeInfo) {
      this.sidenav.rightMenuClicked({
        id: 15,
        component: InformationComponent,
        data: null,
        history: false,
        push: false,
      });
      this.sidenav.infoSideNav('open');
    } else {
      this.sidenav.closeRightSideNav();
      this.sidenav.infoSideNav('closed');
    }
    // }, 10);
  }
  // <======================openEmbed==========================>
  openEmbed(): void {
    const originUrl = location.origin;
    const href: any = this.router.url;
    this.embedUrl = originUrl.concat(href);
    window.open(this.embedUrl, '_blank');
  }
  // <======================Active And Unactive Tool==========================>
  setActive(id: any, allBtnsClass: string, data: any) {
    if (this.mapService.closePanel) {
      this.sidenav.close();
      this.sidenav.leftSideNavState('closed');
      this.mapService.closePanel = false;
    } else {
      this.toolActive = false;
      this.mapService.toolId = id;
      this.mapService.toolData = data;
      const elemId = `button-${id}`;
      const selectedBtn = document.getElementById(elemId);
      this.mapService.allBtns = document.querySelectorAll('.' + allBtnsClass);
      if (id !== 2 && id !== 5) {
        this.sidenav.leftSideNavState('open');
      }

      this.mapService.allBtns.forEach((elem: any) => {
        elem.classList.remove('active');
      });
      if (id !== 3 && id !== 4) {
        selectedBtn?.classList.add('active');
        this.mapService.toolNameForMetrics = false;
      }
      if (id !== 2 && id !== 5) {
        this.sidenav.leftMenuClicked({ data: data });
      }
      if(id != 3 && id != 4) {
        if (id === this.mapService.previousId) {
          this.toolActive = true;
          if (!this.ShortcutKeyCheck) {
            switch (id) {
              case 2:
                if(!this.backForwordTool) {
                  this.activityLoging('Click', 'ZoomBox' + ':Deactivate');
                } else {
                  this.activityLoging('Shortcut', 'ZoomBox' + ':Deactivate');
                  this.backForwordTool = false
                }

                break;
              case 5:
                this.activityLoging('Click', 'GoogleStreetView' + ':Deactivate');
                break;
              default:
                this.activityLoging('Click', this.eventName + ':Deactivate');
                break;
            }
          }
          this.mapService.allBtns.forEach((elem: any) => {
            elem.classList.remove('active');

            this.mapService.toolNameForMetrics = true;
          });
          this.mapService.previousId = null;
          if (id !== 2 && id !== 5) {
            this.sidenav.close();
            this.sidenav.leftSideNavState('closed');
          }
        } else {
          if (id === 2 && id === 5) {
            this.toolActive = false;
          }
          if (!this.ShortcutKeyCheck) {
            switch (id) {
              case 2:
                if(!this.backForwordTool) {
                  this.activityLoging('Click', 'ZoomBox' + ':Activate');
                } else {
                  this.activityLoging('Shortcut', 'ZoomBox' + ':Activate');
                  this.backForwordTool = false
                }
                break;
              case 5:
                this.activityLoging('Click', 'GoogleStreetView' + ':Activate');
                break;
              default:
                this.activityLoging('Click', this.eventName + ':Activate');
                break;
            }
          }

          this.mapService.previousId = id;
        }
      }

    }
  }

  //handle forward backward
  forwardBackward(id: any): void {
    if (id == 3 && this.forwardBackwardService.index > 0) {
      this.forwardBackwardService.back();
      if(this.backForwordTool) {
        this.activityLoging('Shortcut', 'Back:Activate');
        this.backForwordTool = false
      } else {
        this.activityLoging('Click', 'Back:Activate');
      }
    } else if (
      id == 4 &&
      this.forwardBackwardService.index !=
      this.forwardBackwardService.stack.length
    ) {
      this.forwardBackwardService.forward();
      if(this.backForwordTool) {
        this.activityLoging('Shortcut', 'Forward:Activate');
        this.backForwordTool = false
      } else {
        this.activityLoging('Click', 'Forward:Activate');
      }

    }
  }
  //Refresh Tool
  reFresh() {
    this.mapService.mapLayer
      .getLayers()
      .getArray()
      .forEach((a: any) => {
        setTimeout(() => {
          if (
            a.getProperties().allType == 'layers' &&
            a.getProperties().isVisible == true
          ) {
            a.getSource().refresh();
            //setting refresh property for unit testing
            a.setProperties({ refresh: true });
          }
        }, 500);
      });
  }
  //Zoom Box Tool
  zoomBox() {
    // this.activityLoging('Shortcut', 'ZoomBox' + ':Activate');
    setTimeout(() => {
      if (!this.toolActive) {
        this.mapService.zoomBoxCounter = this.mapService.zoomBoxCounter + 1;
        drawZoomBox(
          this.mapService.mapLayer,
          this.mapService,
          this.mapService.toolData,
          this.mapService.zoomBoxCounter,
          !this.toolActive,
          this.ipAddress
        );
      } else {
        this.mapService.zoomLayer &&
          this.mapService.zoomLayer.getSource().clear();
        this.mapService.mapLayer.removeInteraction(this.mapService.drawBox);
        this.mapService.getdrawEnable(false);
        this.mapService.zoomBoxCounter = 0;
      }
    }, 1);
  }
  //google street View
  googleStreetView() {
    setTimeout(() => {
      if (!this.toolActive) {
        this.mapService.counter = this.mapService.counter + 1;
        googleView(
          this.mapService.mapLayer,
          this.mapService,
          this.mapService.toolData,
          this.mapService.counter,
          !this.toolActive,
          this.ipAddress
        );
      } else {
        this.mapService.streetViewLayer &&
          this.mapService.streetViewLayer.getSource().clear();
        this.mapService.mapLayer.removeInteraction(this.mapService.drawBox);
        this.mapService.getdrawEnable(false);
        this.mapService.counter = 0;
      }
    }, 1);
  }

  getGeoPosition() {
    if (this.geoLocationActive) {
      this.geoLocationActive = false;
      this.removeGeoFeature();
    } else {
      this.geoLocationActive = true;
      this.geolocationService.getCurrentPosition().then((position) => {
        position;
        const locationfinal = fromLonLat([position[1], position[0]])
        const extent = this.mapService.mapData.map_data.map_data.initial_bounds;
        const location = containsCoordinate(extent, locationfinal);
        if (location) {
          const format = new WKT();
          const feature = format.readFeature(`POINT (${locationfinal[0]} ${locationfinal[1]})`);
          const style = new Style({
            image: new Icon({
              src: '/assets/img/blue.png',
              imgSize: [80, 80],
              // offset: [-20, -37],
              scale: 0.3,
              opacity: 1.0,
            }),
          });
          feature.set('id', 'geoLocation');
          feature.setStyle(style);
          this.mapService.vectorDrawSource.addFeatures([feature]);
          this.zoomToLocation();
        } else {
          this.dialog.open(GpsErrorModalComponent, {
            position: {
              top: '20%',
            },
            data: {
              title: 'Location Erorr',
              message: this.mapService.getAllModals.gps_error,
            },
          });
          this.geoLocationActive = false;
        }
      });
    }
  }
  removeGeoFeature() {
    const backSource = this.mapService.geoLocationLayer.getSource();
    const features = this.mapService.vectorDrawSource.getFeatures();
    features.forEach((feature: any) => {
      if (feature.get('id') == 'geoLocation') {
        backSource.removeFeature(feature);
      }
    });
  }
  zoomToLocation() {
    const allFeatures = this.mapService.vectorDrawSource.getFeatures();
    for (let i = 0; i < allFeatures.length; i++) {
      if (allFeatures[i].get('id') == 'geoLocation') {
        this.mapService.mapLayer
          .getView()
          .fit(allFeatures[i].getGeometry().getExtent(), { maxZoom: 18 });
      }
    }
  }


  // <======================Hide Show tools==========================>
  hideShowTools() {
    for (let i = 0; i < this.navItems.length; i++) {
      for (const [key, value] of Object.entries(this.tools)) {
        if (this.mapService.bookMarkTool) {
          if (this.navItems[i].toolName == key) {
            if (
              this.navItems[i].toolName === 'save_view' ||
              this.navItems[i].toolName === 'embed' ||
              this.navItems[i].toolName === 'annotator'
            ) {
              this.navItems[i].display = false;
            } else if (
              this.navItems[i].toolName === 'layers' &&
              this.mapService.shareData.basic_data === -999
            ) {
              this.navItems[i].display = true;
            } else {
              this.navItems[i].display = value;
            }
          }
        } else {
          if (this.navItems[i].toolName == key) {
            this.navItems[i].display = value;
          }
        }
      }
    }
    let count: any = 0;
    for (let i = 0; i < this.navItems.length; i++) {
      if (this.navItems[i].display == true) {
        this.sidenav.visibleToolCount = count++;
      }
    }

  }
  // <======================tools tool-tips==========================>
  toolsToolTips() {
    for (let i = 0; i < this.navItems.length; i++) {
      for (const [key, value] of Object.entries(this.toolTips)) {
        if (this.navItems[i].toolName == key) {
          this.navItems[i].tooltip.description = value;
        }
      }
    }
  }
  // <======================Dynamic Data for tools==========================>
  navItems: any[] = [
    {
      id: 1,
      displayName: 'Legend',
      iconName: '/assets/img/tools/layers.png',
      component: LegendToolComponent,
      toolName: 'layers',
      show: 'true',
      tooltip: {
        id: 1,
        name: 'Legend',
        keyword: 'L',
      },
    },
    {
      id: 2,
      displayName: 'Zoom Box',
      iconName: '/assets/img/tools/zoombox.png',
      component: null,
      toolName: 'zoombox',
      show: 'false',
      tooltip: {
        id: 2,
        name: 'Zoom Box',
        keyword: 'O',
      },
    },
    {
      id: 3,
      displayName: 'Back',
      iconName: '/assets/img/tools/back-pv3.png',
      component: null,
      toolName: 'back',
      show: 'false',
      tooltip: {
        id: 3,
        name: 'Back',
        keyword: 'B',
      },
    },
    {
      id: 4,
      displayName: 'Forward',
      iconName: '/assets/img/tools/forward-pv3.png',
      component: null,
      show: 'false',
      toolName: 'forward',
      tooltip: {
        id: 4,
        name: 'Forward',
        keyword: 'F',
      },
    },
    {
      id: 5,
      displayName: 'Google Street View',
      component: null,
      toolName: 'google_maps_street_view',
      show: 'false',
      iconName: '/assets/img/tools/googlify.png',
      tooltip: {
        id: 5,
        name: 'Google Street View',
        keyword: 'G',
      },
    },
    {
      id: 6,
      displayName: 'Metrics',
      component: MetricxComponent,
      toolName: 'metrics',
      show: 'true',
      iconName: '/assets/img/tools/metrics.png',
      tooltip: {
        id: 6,
        name: 'Metrics',
        keyword: 'M',
      },
    },
    {
      id: 7,
      displayName: 'Query',
      toolName: 'query',
      show: 'true',
      component: QueryComponent,
      iconName: '/assets/img/tools/query.png',
      tooltip: {
        id: 7,
        name: 'Query',
        keyword: 'Q',
      },
    },
    {
      id: 8,
      displayName: 'Advanced Select',
      component: AdvanceSelectComponent,
      toolName: 'advanced_select',
      show: 'true',
      iconName: '/assets/img/tools/amass.png',
      tooltip: {
        id: 8,
        name: 'Advanced Select',
        keyword: 'A',
      },
    },
    {
      id: 9,
      displayName: 'Download View',
      component: DownloadViewComponent,
      toolName: 'snapshot',
      show: 'true',
      iconName: '/assets/img/tools/download-pv.png',
      tooltip: {
        id: 9,
        name: 'Download View',
        keyword: 'D',
      },
    },
    {
      id: 10,
      displayName: 'Print View',
      component: PrintviewComponent,
      toolName: 'generate_pdf',
      show: 'true',
      iconName: '/assets/img/tools/print-pv.png',
      tooltip: {
        id: 10,
        name: 'Print View',
        keyword: 'P',
      },
    },
    {
      id: 11,
      displayName: 'Bookmark',
      component: BookmarkComponent,
      toolName: 'save_view',
      show: 'true',
      iconName: '/assets/img/tools/save_view.png',
      tooltip: {
        id: 11,
        name: 'Bookmark',
        keyword: 'V',
      },
    },
    {
      id: 12,
      displayName: 'Live Share',
      component: LiveShareComponent,
      toolName: 'live_share',
      show: 'true',
      iconName: '/assets/img/tools/share.png',
      tooltip: {
        id: 12,
        name: 'Live Share',
        keyword: 'S',
      },
    },
    {
      id: 13,
      displayName: 'Embed',
      component: LiveshareEmbedComponent,
      toolName: 'embed',
      show: 'true',
      iconName: '/assets/img/tools/embed.png',
      tooltip: {
        id: 13,
        name: 'Embed',
        keyword: '',
        description: 'Live Share Embed Tool',
      },
    },
    {
      id: 14,
      displayName: 'Annotation',
      component: AnnotationComponent,
      toolName: 'annotator',
      show: 'true',
      iconName: '/assets/img/tools/annotator.png',
      tooltip: {
        id: 14,
        name: 'Annotation',
        keyword: 'T',
      },
    },
    {
      id: 15,
      displayName: 'Zoom to Perimeter',
      iconName: '/assets/img/tools/locationlink.png',
      component: ZoomToPerimeterComponent,
      toolName: 'zoom_to_perimeter',
      show: 'true',
      tooltip: {
        id: 15,
        name: 'Wildfire Perimeters',
        keyword: 'X',
        description:
          'See list of current fire perimeters and zoom to any of them instantly by clicking the links. Refreshed automatically every hour.',
      },
    },
    {
      id: 16,
      displayName: 'Refresh View',
      iconName: '/assets/img/tools/refresh.png',
      component: null,
      toolName: 'refresh',
      show: 'false',
      tooltip: {
        id: 16,
        name: 'refresh view',
        keyword: 'R',
        description: 'Refreshes real time data feeds.',
      },
    },
    {
      id: 17,
      displayName: 'Geo Lock',
      iconName: '/assets/img/tools/geolock.png',
      component: LiveShareGeoLockComponent,
      toolName: 'geolock',
      show: 'true',
      tooltip: {
        id: 17,
        name: 'Geo Lock',
        keyword: '',
        description: 'Live Share GeoLock Tool',
      },
    },
    {
      id: 18,
      displayName: 'Capture',
      iconName: '/assets/img/tools/capture.png',
      component: CaptureToolComponent,
      toolName: 'capture',
      show: 'true',
      tooltip: {
        id: 18,
        name: '',
        keyword: '',
        description: 'Capture',
      },
    },
    {
      id: 19,
      displayName: 'DEM Downloader',
      iconName: '/assets/img/dem/dem_tool_icon_v1.png',
      component: DemDownloaderComponent,
      toolName: 'dem_downloader',
      show: 'true',
      tooltip: {
        id: 18,
        name: '',
        keyword: '',
        description: 'DEM Downloader',
      },
    },
  ];
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  expandTool() {
    if (this.toolExpand) {
      this.toolCollapse = true;
      this.toolExpand = false;
    }
  }
  collapsedTool() {
    if (this.toolCollapse) {
      this.toolExpand = true;
      this.toolCollapse = false;
    }
  }


  myReports() {
    this.showReports = !this.showReports;
    if (this.showReports) {
      this.assessorParcelService.getUserReports().subscribe((res: any) => {
        this.allUserReports = res;
        for (let i = 0; i < this.allUserReports.length; i++) {
          const newStr = this.allUserReports[i].report_name
            .replace(/([A-Z])/g, ' $1')
            .trim();
          this.allUserReports[i].report_name = newStr;
        }
      });
    }
  }
  downLoadFile(fileNameData: any) {
    this.download = `${this.sidenav.downloadFileUrl}${fileNameData}`;
    const element1: any = document.getElementById('submit-pdf1');
    element1.href = this.download;
    element1.target = '_blank';
    element1.click();
    element1.href = '';
  }

  activityLoging(event: any, eventName: any) {
    if (event === 'Shortcut') {
      this.ShortcutKeyCheck = false;
    }
    const stringEvent = eventName.replace(/\s/g, '');
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: event,
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: stringEvent,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(() => {
          // console.log('a');
        });
      });
  }

  onChangeDemigodMenu(event: any): void {
    if (event.target.value == '500') {
      localStorage.removeItem('subLevel');
    } else {
      localStorage.setItem('subLevel', event.target.value);
    }
    location.reload();
  }
  goToDashboard() {
    if (this.userLevel === '500') {
      this.dashUrl = `${environment.opLink}/dashboard/${this.mapId}/${this.token}`;
    } else {
      this.logOutColl();
      this.dashUrl = '/dashboard/';
      window.open(this.dashUrl, '_blank');
    }
  }

  goToMaps() {
    this.mapsUrl = `${environment.opLink}/my_maps/${this.token}`;
  }

  backToDemigod() {
    this.logOutColl();
    localStorage.clear();
    window.location = <any>`${environment.operatorDashboardUrl}/maps/`;
  }

  goToAccount() {
    if (this.userLevel === '500') {
      if (this.mapService.mapInterface.map_type === 'pv-map') {
        this.accountUrl = `${environment.operatorDashboardUrl}/parcelviewer/account/${this.token}`;
      } else if (this.mapService.mapInterface.map_type == 'custom-map') {
        this.accountUrl = `${environment.operatorDashboardUrl}/customviewer/account/${this.token}`;
      } else {
        this.accountUrl = `${environment.operatorDashboardUrl}/wildfireviewer/account/${this.token}`;
      }
    } else {
      this.logOutColl();
      this.accountUrl = '/dashboard/';
    }
  }

  logOutColl(): void {
    this.mapService.isLiveShareLink = 'false';
    const colType = localStorage.getItem('coltype');
    if (colType === 'collaborate') {
      const body: any = { map: +this.mapService.mapId };
      this.mapService.collaboratorDestroySession(body).subscribe(() => {
        //
      });
      this.loginShow = true;
    }
  }

  @HostListener('window:beforeunload')
  async ngOnDestroy() {
    await this.logOutColl();
  }
  @HostListener('window:beforeunload', ['$event']) beforeunloadHandler() {
    this.logOutColl();
  }


}
